<template>
    <div id="exampleCode">
        <div class="exampleCodeWrap">
            <div class="exampleCodeTitle">完整教学代码示例</div>
            <div class="exampleCodeTab">
                <div class="tabNav">
                    <span style="margin-right: 87px;">名称</span>
                    <span style="margin-right: 73px;">标题</span>
                    <span style="margin-right: 71px;">提供者</span>
                    <span>时间</span>
                </div>
                <p>暂无教学代码，小M正在拼命添加中....</p>
            </div>
            <div class="exampleCodeTitle">常见问题</div>
            <div class="problemWrap">
                <div class="problemList">
                    <span>内容</span>
                    <span>详细</span>
                </div>
                <p>常见问题: FAQ网址</p>
            </div>
        </div>
    </div>

</template>

<script>
    export default {
        name: "InformationExampleCode",
        mounted() {
            /*淡入淡出效果*/
            window.addEventListener('scroll', this.scrollFun);
            this.scrollFun();
        },
        methods: {
            scrollFun() {
                this.$animate(document.getElementsByClassName("exampleCodeWrap")[0], "fadeInUp");
            }
        },
        beforeDestroy() {
            /*销毁监听*/
            window.removeEventListener('scroll', this.scrollFun);
        }
    }
</script>

<style lang="scss" scoped>
    #exampleCode {
        .exampleCodeTitle {
            margin-bottom: 30px;
            font-weight: 600;
            font-size: 16px;
            color: #152346;
        }
        .exampleCodeWrap {
            width: 1200px;
            margin: 0 auto;
            padding-top: 74px;
            .exampleCodeTab {
                width: 100%;
                padding: 20px;
                margin-bottom: 72px;
                border: 1px solid #D5D9DF;
                border-radius: 5px;
                .tabNav {
                    display: flex;
                    align-items: center;
                    margin-bottom: 8px;
                    span {
                        font-size: 16px;
                        color: #152346;
                    }
                }
                p {
                    font-size: 16px;
                    color: #152346;
                    line-height: 32px;
                }
            }
            .problemWrap {
                .problemList {
                    display: flex;
                    align-items: center;
                    padding-bottom: 12px;
                    margin-bottom: 12px;
                    border-bottom: 1px solid rgba(0, 0, 0, 0.05);
                    span {
                        margin-right: 103px;
                        font-size: 16px;
                        color: #152346;
                    }
                }
                p {
                    font-size: 16px;
                    color: #152346;
                }
            }
        }
    }
</style>